package org.moxultimate.topwithmox.libraries

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.components.icons.fa.FaBell
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaGear
import com.varabyte.kobweb.silk.components.icons.fa.FaHeart
import com.varabyte.kobweb.silk.components.icons.fa.FaHouse
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlass
import com.varabyte.kobweb.silk.components.icons.fa.FaStar
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.MdiEmail
import com.varabyte.kobweb.silk.components.icons.mdi.MdiFavorite
import com.varabyte.kobweb.silk.components.icons.mdi.MdiHome
import com.varabyte.kobweb.silk.components.icons.mdi.MdiMenu
import com.varabyte.kobweb.silk.components.icons.mdi.MdiPerson
import com.varabyte.kobweb.silk.components.icons.mdi.MdiSearch
import com.varabyte.kobweb.silk.components.icons.mdi.MdiSettings
import com.varabyte.kobweb.silk.components.icons.mdi.MdiStar
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.cssRem

/**
 * Demonstrates Font Awesome (FA) and Material Design Icons (MDI) from Kobweb Silk.
 *
 * Both icon sets are generated as individual @Composable functions. Use
 * [Modifier.fontSize] to control size — icons scale with the current font size.
 *
 * Font Awesome:
 * - Import: com.varabyte.kobwebx.silk.icons.fa.*
 * - Naming: Fa<IconName> — e.g., [FaUser], [FaHouse], [FaStar]
 * - Style variants: [IconStyle.FILLED] (default), [IconStyle.OUTLINE]
 * - Size variants: [IconSize] enum (XS → 2XL) or override with Modifier.fontSize
 *
 * Material Design Icons:
 * - Import: com.varabyte.kobwebx.silk.icons.mdi.*
 * - Naming: Mdi<IconName> — e.g., [MdiHome], [MdiStar], [MdiFavorite]
 */
@Composable
fun SilkIconsSample() {
    val iconModifier = Modifier.fontSize(1.5.cssRem)

    Column(Modifier.gap(1.5.cssRem)) {

        // ── Font Awesome icons ────────────────────────────────────────────────
        SpanText("Font Awesome")
        Row(Modifier.gap(1.cssRem)) {
            FaUser(modifier = iconModifier)
            FaHouse(modifier = iconModifier)
            FaStar(modifier = iconModifier)
            FaHeart(modifier = iconModifier)
            FaEnvelope(modifier = iconModifier)
            FaBell(modifier = iconModifier)
            FaGear(modifier = iconModifier)
            FaMagnifyingGlass(modifier = iconModifier)
        }

        // ── FA with style variants ────────────────────────────────────────────
        SpanText("FA — Filled vs Outlined")
        Row(Modifier.gap(1.cssRem)) {
            FaStar(modifier = iconModifier, style = IconStyle.FILLED)
            FaStar(modifier = iconModifier, style = IconStyle.OUTLINE)
            FaHeart(modifier = iconModifier, style = IconStyle.FILLED)
            FaHeart(modifier = iconModifier, style = IconStyle.OUTLINE)
        }

        // ── Material Design Icons ─────────────────────────────────────────────
        SpanText("Material Design Icons")
        Row(Modifier.gap(1.cssRem)) {
            MdiHome(modifier = iconModifier)
            MdiStar(modifier = iconModifier)
            MdiFavorite(modifier = iconModifier)
            MdiEmail(modifier = iconModifier)
            MdiPerson(modifier = iconModifier)
            MdiSearch(modifier = iconModifier)
            MdiSettings(modifier = iconModifier)
            MdiMenu(modifier = iconModifier)
        }
    }
}
